export default function safeJsonParse(string, fallback = null) {
  try {
    return JSON.parse(string);
  } catch (e) {
    return fallback ?? string;
  }
}
